import React, { Component, Fragment } from "react";
import { InputItem, List, Toast, WingBlank } from "antd-mobile";
import { createForm } from "rc-form";
import { connect } from "dva";
import { Link } from "dva/router";
@connect()
class Register extends Component {
    render() {
        const { dispatch } = this.props;
        const { getFieldProps } = this.props.form;
        const handleClick = () => {
            let mobile = getFieldProps("mobile").value;
            console.log(mobile);
            if (!mobile) {
                Toast.info("请填写手机号", 1);
                return;
            }
            mobile = mobile.replace(/\s/g, "");
            if (
                !/^((13[0-9])|(14[5,6,7,9])|(15[^4])|(16[5,6])|(17[0-9])|(18[0-9])|(19[1,8,9]))[0-9]{8}$/.test(
                    mobile,
                )
            ) {
                Toast.info("手机号不正确", 1);
                return;
            }
            Toast.loading();
            dispatch({
                type: "app/register",
                payload: {
                    mobile,
                },
            });
        };
        return (
            <Fragment>
                <List renderHeader={() => ""}>
                    <InputItem
                        {...getFieldProps("mobile")}
                        clear
                        placeholder="请输入手机号"
                        type="phone"
                    >
                        手机号
                    </InputItem>
                    <List.Item>
                        <div
                            style={{
                                width: "100%",
                                color: "#108ee9",
                                textAlign: "center",
                            }}
                            onClick={handleClick}
                        >
                            注册
                        </div>
                    </List.Item>
                    <List.Item>
                        <Link to="/login">
                            <div
                                style={{
                                    width: "100%",
                                    color: "#000",
                                    textAlign: "center",
                                }}
                            >
                                返回
                            </div>
                        </Link>
                    </List.Item>
                </List>
                <div style={{ padding: "20px", fontSize: 12, color: "#f00" }}>
                    注册成功后会返回您的登录密码，请记住保存您的登录密码,默认密码为手机号后6位。
                </div>
            </Fragment>
        );
    }
}
const RegisterPage = createForm()(Register);
export default RegisterPage;
